import React from 'react';
import { Link } from 'react-router-dom';
//todo: make sure SDP scss doesn't contain unused styles that was copied here
import styles from './SimilarShops.module.scss';
import { FormattedMessage } from 'react-intl';

import { ReactComponent as ArrowRightIcon } from '../../images/icons/arrowRight.svg';
import { ReactComponent as ReviewIcon } from '../../images/icons/review.svg';
import Rating from '../Rating/Rating';

const SimilarShops = ({ similarShops }) => {
  return (
    <div className={styles.similarShops}>
      {similarShops.map((shop, index) => {
        return (
          <Link to={shop.slug} className={styles.similarShop} key={shop.title + index}>
            <div className={styles.shopImageContainer}>
              {!!shop?.shop_logo?.shop_logo && (
                <>
                  {/* Image dimensions: h=63 */}
                  <img
                    src={shop.shop_logo.shop_logo_233_100 || shop.shop_logo.shop_logo}
                    alt={`${shop.title} logo`}
                    title={`${shop.title} logo`}
                    loading="lazy"
                    width="147"
                    height="63"
                  />
                </>
              )}
            </div>
            <div className={styles.divider} />
            <div className={styles.shopContent}>
              <div className={styles.similarShopTitle}>{shop.title}</div>
              <div className={styles.similarShopRatings}>
                <Rating value={shop.rating?.rating} />
                <span className={styles.similarShopRatingsCount}>
                  <ReviewIcon /> {shop.rating?.votes || 0}
                </span>
              </div>
              <span className={styles.seeMore}>
                <FormattedMessage id="common.seeMore" defaultMessage="See more" />
                <ArrowRightIcon viewBox="0 0 16 16" />
              </span>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default SimilarShops;
